import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import authService from '../services/authService';

export default function AdminProtectedRoute({ children }) {
  const location = useLocation();
  
  // Check if user is authenticated as regular user
  if (authService.isAuthenticated() && !authService.isAdminAuthenticated()) {
    // Regular user is logged in, redirect to dashboard
    return <Navigate to="/" replace />;
  }
  
  // Check if admin is authenticated
  if (!authService.isAdminAuthenticated()) {
    // No admin authentication, redirect to login page
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
